import React, { Component } from "react";
import { Translate } from "react-redux-i18n";
import { connect } from "react-redux";
import { setAlert } from "../../../actions/alertActions";
import "../../../styles/components/ceme/sections/Join.scss";

class Join extends Component {
  render() {
    return (
      <>
        <a id="section4" href="#section4" className="anchor-activation">
          {null}
        </a>
        <div id="join">
          <div className="small-content-section">
            <div className="special-title">PLATAFORMA EVIO</div>
            <div className="content">
              <div className="item">
                <span>
                  <Translate value="siteCeme_advantages_card1" />
                </span>
              </div>
              <div className="item">
                <span>
                  <Translate value="siteCeme_advantages_card2" />
                </span>
              </div>
              <div className="item">
                <span>
                  <Translate value="siteCeme_advantages_card3" />
                </span>
              </div>
              <div className="break" />
              <div className="item">
                <span>
                  <Translate value="siteCeme_advantages_card4" />
                </span>
              </div>
              <div className="item">
                <span>
                  <Translate value="siteCeme_advantages_card5" />
                </span>
              </div>
              <div className="item">
                <span>
                  <Translate value="siteCeme_advantages_card6" />{" "}
                  <a href="https://evio.pt/"> aqui</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(null, {
  setAlert,
})(Join);
